import { useMemo, useState } from "react";
import { X } from "lucide-react";
import { salvarMovimentacao } from "../services/financeService";
import { hojeISO, moedaParaNumero } from "../utils/money";

export default function QuickEntryModal({ uid, categorias = [], onClose }) {
  const [tipo, setTipo] = useState("receita");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [categoria, setCategoria] = useState("");
  const [data, setData] = useState(hojeISO());
  const [observacao, setObservacao] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");

  const categoriasFiltradas = useMemo(() => {
    return categorias.filter((cat) => cat.tipo === tipo);
  }, [categorias, tipo]);

  function formatarValorDigitado(texto) {
    let valorDigitado = String(texto || "");

    valorDigitado = valorDigitado.replace(/\./g, ",");

    valorDigitado = valorDigitado.replace(/[^\d,]/g, "");

    const partes = valorDigitado.split(",");

    if (partes.length > 2) {
      valorDigitado = partes[0] + "," + partes.slice(1).join("");
    }

    return valorDigitado;
  }

  async function salvar(e) {
    e.preventDefault();
    setErro("");

    if (!uid) {
      setErro("Usuário não encontrado. Saia e entre novamente.");
      return;
    }

    const valorNumerico = moedaParaNumero(valor);

    if (!valorNumerico || valorNumerico <= 0) {
      setErro("Informe um valor válido.");
      return;
    }

    try {
      setSalvando(true);

      await salvarMovimentacao(uid, {
        tipo,
        descricao,
        valor: valorNumerico,
        categoria: categoria || categoriasFiltradas[0]?.nome || "Outros",
        data,
        observacao,
      });

      onClose();
    } catch (error) {
      console.error("Erro ao salvar movimentação:", error);
      setErro(error.message || "Erro ao salvar lançamento.");
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div className="modal-backdrop">
      <section className="modal-card glass-card">
        <header className="modal-header">
          <div>
            <h2>Entrada rápida</h2>
            <p className="muted">
              Registre uma receita ou despesa em poucos segundos.
            </p>
          </div>

          <button className="icon-btn" onClick={onClose} type="button">
            <X size={20} />
          </button>
        </header>

        <form onSubmit={salvar} className="quick-form">
          <div className="type-switch">
            <button
              type="button"
              className={tipo === "receita" ? "selected income" : ""}
              onClick={() => {
                setTipo("receita");
                setCategoria("");
              }}
            >
              Receita
            </button>

            <button
              type="button"
              className={tipo === "despesa" ? "selected expense" : ""}
              onClick={() => {
                setTipo("despesa");
                setCategoria("");
              }}
            >
              Despesa
            </button>
          </div>

          <label>
            Descrição
            <input
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Ex: venda, mercado, aluguel"
              required
            />
          </label>

          <label>
            Valor
            <input
              value={valor}
              onChange={(e) => setValor(formatarValorDigitado(e.target.value))}
              placeholder="Ex: 150,00"
              inputMode="decimal"
              type="text"
              required
            />
          </label>

          <div className="two-cols">
            <label>
              Categoria
              <select
                value={categoria}
                onChange={(e) => setCategoria(e.target.value)}
              >
                <option value="">Selecionar</option>

                {categoriasFiltradas.map((cat) => (
                  <option key={cat.id} value={cat.nome}>
                    {cat.icone} {cat.nome}
                  </option>
                ))}
              </select>
            </label>

            <label>
              Data
              <input
                type="date"
                value={data}
                onChange={(e) => setData(e.target.value)}
              />
            </label>
          </div>

          <label>
            Observação
            <textarea
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              placeholder="Opcional"
            />
          </label>

          {erro && <p className="error-text">{erro}</p>}

          <button className="primary-btn" disabled={salvando} type="submit">
            {salvando ? "Salvando..." : "Salvar lançamento"}
          </button>
        </form>
      </section>
    </div>
  );
}